import TYPE from './storeType'

const mutations={
  //用户USERID
  SET_COMPANY_INFO(state, info) {
    state.companyInfo = info
  },
  SET_LOADING(state, status) {
    state.isLoading = status
  }
}
export default mutations



// WEBPACK FOOTER //
// ./src/store/mutations.js